import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {message} from "antd"
import ModalChangeStatus from "./ModalChangeStatus"
import {bulkUpdateStatus} from "../../../../services/api/apiSku"

class ChangeStatusProduct extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            loading: false,
            error: '',
            is_active: false
        }
    }

    _toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    _handleChangeStatus = (value) => {
        this.setState({
            is_active: value
        })
    }

    _bulkActionChangeStatus = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {arrSelected} = this.props
            const {is_active} = this.state
            const payload = {
                ids: arrSelected,
                status: is_active
            }
            const {'data': responsive} = await bulkUpdateStatus(payload)

            const {success, message: error} = responsive

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                error: '',
            }, () => {
                const {onRefresh, closeOpen} = this.props

                this._toggle()

                if (typeof onRefresh === 'function') {
                    onRefresh()
                }
                if (typeof closeOpen === 'function') {
                    closeOpen()
                }
                message.success('Sửa sản phẩm thành công');
            })
        } catch (err) {
            this.setState({
                loading: false,
                error: err.message
            })
        }
    }

    render() {
        const {arrSelected} = this.props
        const {isOpen, loading, error, is_active} = this.state

        return (
            <div className='ChangeStatusProduct'>
                <Button onClick={this._toggle} color='link'>Thay đổi trạng thái </Button>
                <ModalChangeStatus
                    isOpen={isOpen}
                    loading={loading}
                    error={error}
                    toggle={this._toggle}
                    arrSelected={arrSelected}
                    status={is_active}
                    onChange={this._bulkActionChangeStatus}
                    onChangeStatus={this._handleChangeStatus}
                />
            </div>
        )
    }
}

ChangeStatusProduct.propTypes = {
    arrSelected: PropTypes.array,
    onRefresh: PropTypes.func
}

export default ChangeStatusProduct